import React from 'react';
import {View} from 'react-native';
// import Button from '@/components/basic/button';
import {Image} from 'antd-mobile';
import theme from '@/style';
// import {goTo} from '@/utils';
import {useTranslation} from 'react-i18next';
import PhoneIcon from '@/assets/imgs/invitation/phoneIcon.webp';

interface BindPhoneModalProps {
  onBind?: () => void;
}

const BindPhoneModal: React.FC<BindPhoneModalProps> = () => {
  const {t} = useTranslation();

  return (
    <View style={[theme.flex.col, theme.flex.center]}>
      <div className="flex flex-col items-center justify-center gap-5 text-white ">
        <Image src={PhoneIcon} width={72} height={72} />
        <div className="flex flex-col gap-2">
          <div className="text-xl font-bold text-center text-t1 font-inter tracking-tight capitalize leading-[normal]">
            {t('invitation.bind_phone.title')}
          </div>

          <div className="text-sm text-t2 font-inter font-medium tracking-tight capitalize leading-[normal] text-center">
            {t('invitation.bind_phone.tip')}
          </div>
        </div>
      </div>
    </View>
  );
};

export default BindPhoneModal;
